export const GET_CAMPAIGNMETRIC_URL = "api/v1/campaignmetric";
export const GET_CAMPAIGN_DETAILS_URL = "api/v1/campaign/details";
